import {
	formatChambre,
	formatActeur,
	formatDate,
	sanitize,
	formatCell,
} from "../formatters";
import { SpeechIcon } from "@logora/parliament.icons.regular_icons";

const columns = [
	{
		header: "Chambre",
		accessorKey: "chambre",
		cell: (info) => formatChambre(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Chambre",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "AN",
						label: "AN",
					},
					{
						value: "SN",
						label: "SN",
					},
				],
			},
		},
	},
	{
		header: "Date",
		accessorKey: "dateSeance",
		cell: (info) => formatDate(formatCell(info)),
		defaultSorting: "desc",
		meta: {
			filter: {
				label: "Date",
				variant: "date-range",
				labels: ["Après le", "Avant le"],
			},
		},
	},
	{
		header: "Auteur",
		accessorKey: "acteurRef",
		cell: (info) => formatActeur(formatCell(info)),
		enableSorting: false,
	},
	{
		header: "Texte",
		accessorKey: "texte",
		enableSorting: false,
		cell: (info) => (
			<p dangerouslySetInnerHTML={sanitize(info.getValue())} />
		),
	},
	{
		header: "Code Grammaire",
		accessorKey: "codeGrammaire",
		isVisible: false,
		meta: {
			filter: {
				label: "Code Grammaire",
				variant: "text",
				defaultValue: "PAROLE_GENERIQUE",
				showInFilterBar: false
			},
		},
	},
	{
		header: "Est président",
		accessorKey: "estPresident",
		isVisible: false,
		meta: {
			filter: {
				label: "Est président",
				variant: "boolean",
				defaultValue: false,
				showInFilterBar: false,
			},
		},
	}
]

export const interventionDataset = {
	key: "interventions",
	name: "Interventions",
	columns: columns,
	filterMapping: { organeRefUid: "acteurRef_groupeParlementaireUid" },
	include: ["acteurRef.groupeParlementaire", "acteurRef.mandatPrincipal", "debatRef"],
	icon: <SpeechIcon width={20} height={20} />,
	searchPlaceholder: "Rechercher une intervention...",
	rowRedirect: (item) =>
		`/parliament/reunions/${item.debatRef.reunionRefUid}#intervention_${item.ordreAbsoluSeance}`,
};
